import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { hexColorZodSchema } from "@@/shared/stylable/hex-color/hex-color";
import { z } from "zod";
import { pageIdZodSchema } from "../page-id";
import { pageBlockIdZodSchema } from "./page-block-id";

const pageBlockBaseZodSchema = z.object({
    _id: pageBlockIdZodSchema,
    _type: z.literal("PAGE_BLOCK"),
    _createdAt: isoAndUnixZodSchema,
    pageId: pageIdZodSchema,
    backgroundColor: hexColorZodSchema.optional(),
    textColor: hexColorZodSchema.optional(),
    accentColor: hexColorZodSchema.optional(),
});

type _PageBlockBase = z.infer<typeof pageBlockBaseZodSchema>;

export { pageBlockBaseZodSchema };
export type { _PageBlockBase };
